export default __webpack_public_path__ + "static/BasierCircle-BoldItalic-24e0fae0d5a67e6da757fd567948be5d.woff";